import { SvgIcon, SvgIconProps } from '@mui/material';

export const VenmoIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 19 20" {...props}>
      <path
        opacity="0.4"
        d="M11.5612 1.27271C11.9661 2.10981 12.2252 3.12644 12.2252 4.61902C12.2251 7.34586 10.2719 11.3454 8.68905 13.8905L6.99514 0.435438L0 1.09092L3.20385 20L11.1927 20C14.6904 15.4549 19 8.98214 19 3.99955C19 2.43736 18.6679 1.20067 17.9314 0L11.5612 1.27271Z"
        fill="#0088CC"
      />
    </SvgIcon>
  );
};
